import { render, staticRenderFns } from "./EditDetailDialog.vue?vue&type=template&id=12b1154e&scoped=true"
import script from "./EditDetailDialog.vue?vue&type=script&lang=js"
export * from "./EditDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./EditDetailDialog.vue?vue&type=style&index=0&id=12b1154e&prod&scoped=true&lang=css"
import style1 from "./EditDetailDialog.vue?vue&type=style&index=1&id=12b1154e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b1154e",
  null
  
)

export default component.exports